export default __webpack_public_path__ + "static/media/tete98.c6a41592.png";